import { NAVIGATE_TO_INDEX, NAVIGATE_TO_FORM } from "./actions"

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case NAVIGATE_TO_INDEX:
      return {
        ...state,
        view: "index",
      }
    case NAVIGATE_TO_FORM:
      return {
        ...state,
        view: "form",
      }
    default:
      return { ...state }
  }
}

export const propsToState = (props) => {
  return {
    astuteCredentials: props.astuteCredentials,
    tenantSlug: props.tenantSlug,
    paths: props.paths,
    view:
      props.astuteCredentials && props.astuteCredentials.id ? "index" : "form",
  }
}
